import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { WhiteLabelingInterceptor } from './services/white-labeling.interceptor';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WhiteLabelingInterceptor,
      multi: true,
    },
  ],
})
export class SharedWhiteLabelingModule {}
